import React, { useEffect, useMemo, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Collapse from "@mui/material/Collapse";
import TableHead from "@mui/material/TableHead";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import styled from "styled-components";
import {
  generateSilkImagePath,
  getSilkImagePath,
  generateHorseProfileUrl,
  adobeData, generateAdobeDataRaceNo, generateAdobeDataHorseName, defaultValue,
} from "@/app/utils/Common";
import { formattedDate } from "@/app/utils/DayJS";
import RaceCardPerformance from "@/app/ui/Common/RaceCardPerformance";
import DetailTable from "./DetailTable";
import DefaultSort from "@/app/ui/Common/SvgComponent/DefaultSort";
import AsceSort from "@/app/ui/Common/SvgComponent/AsceSort";
import DescSort from "@/app/ui/Common/SvgComponent/DescSort";
import { LANGTYPE_EN, LangCode, useLanguage } from "@/app/utils/LanguageContext";
import { useMyContext } from "@/app/utils/MyContext";
import _ from "lodash";
import { runnerStatus } from "@/app/utils/constant/statusSet";
import { text_size } from "@/app/utils/MixinSize";
import GearInfo from "../GearInfo";
import FullFormM from "./FullFormM";
import PopUpSorter, { Order, Sorting } from "@/app/ui/Common/PopUpSorter";
import { getHorsePerformance } from "@/app/utils/request/requestList";
import VideoPlayerIcon from "@/app/ui/Common/SvgComponent/VideoPlayerIcon";
import VideoPlayerIconBlue from "@/app/ui/Common/SvgComponent/VideoPlayerIconBlue";
import { VideoWAData } from "@/app/ui/Common/VideoPlayer/player";
import { generateVideoSource, generateVideoUrl, validateVideo } from "@/app/utils/Video";
import { MultiVideoSource, VIDEOMODE_M, VIDEOMODE_S } from "@/app/utils/class/common/video";

function compare(property: any, sortList: any) {
  return (a: any, b: any) => {
      const rules = sortList;
      return rules?.indexOf(a[property]) - rules?.indexOf(b[property]);
  } 
}

const HorseLink = styled.a<{ isOpen: boolean }>`
  color: ${({ isOpen }) => (isOpen ? "white" : "#122c68")};
  &:hover {
    text-decoration: underline;
  }
`;

const StyledTableRow = styled(TableRow)<{ isOpen: boolean }>`
  background-color: ${({ isOpen }) =>
    isOpen ? "#173E96 !important" : "rgba(255, 255, 255, 1) !important"};
  border-bottom: 1px solid rgba(204, 204, 204, 1);
  &:nth-last-of-type(2) {
    border-bottom: none;
  }
`;
const MyTableContainer = styled(TableContainer)`
  border-radius: 0 0 4px 4px;
  overflow-x: auto;
`;
const CustomTableCell = styled(TableCell)<{
  customStyle?: any;
  isHorseNo?: boolean;
  isHorse?: boolean;
  isOpen?: any;
}>`
  &.${tableCellClasses.head} {
    background: rgba(225, 225, 225, 1);
    ${text_size(11)}
    height: 44px;
    padding: 0 5px;
    line-height: normal;
    border-bottom: none;
  }
  &.${tableCellClasses.body} {
    padding: 0 8px;
    height: 56px;
    ${({ isHorseNo, isHorse, isOpen }) => {
      if (isHorseNo) return isOpen ? text_size(21) : text_size(15);
      if (isHorse) return isOpen ? text_size(18) : text_size(13);
      return text_size(13);
    }}

    color: ${({ isOpen }) => (isOpen ? "white" : "unset")};
    vertical-align: middle;
    border-bottom: none;
    ${({ customStyle }) => customStyle}
    ${({ isHorseNo, isHorse, isOpen }) => {
      return `font-weight: ${(isHorseNo || isHorse) && isOpen ? 700 : 500}`;
    }}
  }
`;
const ColorWrapper = styled.div`
  background: #fff;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
`;
const CustomSortLabel = styled(TableSortLabel)<{
  isReserve?: boolean;
}>`
  padding: 0;
  padding-right: ${({ isReserve }) => (isReserve ? "18px" : "0")};
  cursor: ${({ isReserve }) => (isReserve ? "text" : "pointer")};
  text-align: center;
  line-height: 16px;

  & .MuiTableSortLabel-icon {
    opacity: 1;
    &:hover {
      opacity: 1;
    }
  }
`;
const LabelCpImg = styled.img<{ open: boolean }>`
  transform: rotate(${({ open }) => (open ? "-180deg" : "0deg")});
`;
const CpImg = styled.img<{ open: boolean }>`
  margin-left: 4.9px;
  transform: rotate(${({ open }) => (open ? "-180deg" : "0deg")});
  filter: invert(${({ open }) => (open ? "100%" : "0%")});
`; 
const ScratchText = styled.p<{ isMobile ?: boolean }>`
  padding-left: ${({ isMobile }) => (isMobile ? "56px" : "0")};
    
`;

const WrapperUnraced = styled.div`
  width: 100%;
  background: rgba(193, 201, 217, 1);
  border-radius: 4px;
  padding: 12px 12px 32px 12px;
`;
const DivUnraced = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${text_size(13)}
  font-weight: 500;
  height: 150px;
`;

// mobile
const MCardListWrapper = styled.div``;
const MCardListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 10px;
  background: var(--Secondary, #6176A0);
  width: 100%;
  height: 40px;
  color: #fff;
  span {
    ${text_size(15)}
    font-weight: 500;
    line-height: 16px;
    text-align: left;
  }
  .mobileSortingIcon {
    width: 29px;
    height: 17px;
    color: #fff;
  }
`;
const MReserveText = styled.p`
  ${text_size(15)}
  font-weight: 500;
  line-height: 22px;
  margin: 24px 12px 0 12px;
`;
const Div12px = styled.div`
  height: 12px;
  background: transparent;
`;
const MCardItem = styled.div`
  margin: 0 12px;
  border-radius: 4px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
`;

const MCardContent = styled.div<{ $top: string }>`
  padding: 0;
  position: sticky;
  top: ${({$top}) => $top};
  background: white;
  z-index: 20;
  border-radius: 4px;
`;

const MItemStyle = styled.div<{ isSelect: boolean }>`
  padding: 8px 8px 12px;
  color: ${({isSelect}) => isSelect ? "#000": "#fff"};
  background: ${({isSelect}) => isSelect ? "#173E96": "#fff"};
  border-radius: 4px 4px 0 0;
`
const MItemTitle = styled.p<{ isSelect: boolean }>`
  padding-left: 4px;
  ${text_size(15)}
  font-weight: 500;
  line-height: 22px;
  text-align: left;
  color: ${({isSelect}) => isSelect ? "#fff" :"rgba(9, 37, 78, 1)"};
  span{
    width: 48px;
    display: inline-block;
    text-align: center;
  }
`;
const MItemName = styled.div<{ isSelect: boolean }>`
  ${text_size(13)} 
  font-weight: 300;
  line-height: 14px;
  text-align: left;
  color: ${({isSelect}) => isSelect ? "#fff" :"rgba(18, 44, 104, 1)"};
`;
const MItemValue = styled.p<{ isSelect: boolean }>`
  ${text_size(13)}
  font-weight: 500;
  line-height: 17px;
  text-align: left;
  color: ${({isSelect}) => isSelect ? "#fff" :"rgba(0, 0, 0, 1)"};
`;
const MItemTop = styled.div``;
const MRunnerJTWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
  margin-top: 4px;
`;
const MRunnerJT = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 1px;
  }
`;
const MRunnerRight = styled.div`
  border-left: 1px solid rgba(180, 180, 180, 1);
  padding: 0 8px;
`;
const MRunnerWLWrapper = styled.div`
  border-top: 1px solid rgba(180, 180, 180, 1); 
  display: flex;
  margin-top: 8px;
  padding: 9.5px 20px 0px 60px;
  align-items: center;
  justify-content: space-between;
  div { 
    align-items: center;
    display: flex; 
    
  }
  &.release1b{
    padding: 8px 0 0 0;
  }
  &.release1b div{
    align-items: start;
    flex-direction: column;
    p{
      line-height: 24px;
      margin-top: 4px;

      svg{
        vertical-align: bottom;
      }
    }
  }
  >div:first-child {
    padding-right: 6px;
  }
`;
const MarginLeft12 = styled.div`
  margin-left: 12px; 
`;
const Margintop5 = styled.div`
  margin-top: 5px;
`;
const MItemBottom = styled.div`
  margin-top: 8px;
  padding: 0 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const LeftBtn = styled.div`
  line-height: 28px;
  border-radius: 30px;
  background-color: rgba(226, 237, 246, 1);
  box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 1);
  }
  &:active {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
  &.selected {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
`;
const RightBtn = styled.div`
  flex-basis: 60%;
  line-height: 28px;
  border-radius: 30px;
  background-color: rgba(226, 237, 246, 1);
  box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 28px;
    text-align: center;
    color: rgba(0, 0, 0, 1);
  }
  &:active {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
  &.selected {
    p {
      color: white;
    }
    background-color: rgba(23, 62, 150, 1);
  }
`;
const HorseLinkM = styled.a<{ isSelect: boolean }>`
  color: ${({isSelect}) => isSelect ? "#fff" :"rgba(18, 44, 104, 1)"};
  padding-left: 8px;
  &:hover {
    text-decoration: underline;
  }
`;
const mStaticSortings: any = [
  {
    id: "HorseNo",
    labelKey: "horseNo",
    showSort: true,
    sortType: "numerical",    
  },
  {
    id: "Weight_lbs",
    labelKey: "weight",
    showSort: true,
    sortType: "numerical",
  },
  {
    id: "Jockey",
    labelKey: "jockey",
    showSort: true,
    sortType: "alphabetical",
  },
  {
    id: "Draw",
    labelKey: "draw",
    showSort: true,
    sortType: "numerical",
  },
  {
    id: "Trainer",
    labelKey: "trainer",
    showSort: true,
    sortType: "alphabetical",
  },
];
const scratchedHorseCells: any = ["HorseNo", "Colour", "Horse", "Other"];
const getValidMultiSources = async (sources: any) => {
  let vPaths = [];
  if (sources?.[VIDEOMODE_S]) vPaths.push({type: VIDEOMODE_S, url: sources[VIDEOMODE_S]})
  if (sources?.[VIDEOMODE_M]) vPaths.push({type: VIDEOMODE_M, url: sources[VIDEOMODE_M]})
  let src = await Promise.all(vPaths.map(async (s:any, idx:number) => {
      const { type, url } = s;
      let videoUrl = generateVideoUrl(url);
      let validation = await validateVideo(videoUrl);
      if (validation.hasVideo()){
        return new MultiVideoSource(type, generateVideoSource(videoUrl.sd, videoUrl.hd, validation), s.type === VIDEOMODE_M);
      }
      return null;
    })
  );
  const validSources = src?.filter((item): item is MultiVideoSource => item !== null);
  return validSources;
};

const EnhancedTable = React.forwardRef((props:any, ref) => {
  const {
    tableData,
    raceNo,
    hasOrderBy,
    isReserve,
    propDetail,
    propDynamicColumn,
    colunmConfigList,
    selectTabPC,
    raceCountry,    
    isSticky
  } = props;
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const defaultOrder = "asc";
  const defaultOrderBy = "HorseNo";
  const [order, setOrder] = React.useState<Order>(defaultOrder);
  const [orderBy, setOrderBy] = React.useState(defaultOrderBy);
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [renderData, setRenderData] = useState<any>([]);
  const [allOpen, setAllOpen] = useState(false);

  const [headCells, setheadCells] = useState<any>([]);
  const [sortings, setSortings] = useState<Sorting[]>([]);
  const [curColumns, setcurColumns] = useState<any>([]);
  const BtnGrpRef = useRef<HTMLDivElement | null>(null);

  const OneBSwitch = window.globalConfig?.OneBSwitch;
  const TWO_A_SWITCH = window.globalConfig?.TwoASwitch;
  const onRunReplayItemClick = async (rowData:any, type?: any, date?:any) => {
    const horseName = rowData?.Horse_en || rowData?.horse?.name_en;
    const countryName = myContextState.selectedMeeting?.countryNameEn || '';
    const raceNo = generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo?.valueOf());
    const horse = generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, horseName)
    props?.setvideoTitle(t('result_race_replay'));
  if (TWO_A_SWITCH){
    if (!props?.handleOpenVideoPlayer)
    {
      console.error('handleOpenVideoPlayer func not found')
      return;
    }
    console.log("onRunReplayItemClick", type ,rowData);
    var mSrc = type === "LastRace" ? rowData?.videoLatestLastrun : getVideoByDate(rowData?.videos, date); // for ExpandHorseRecord
    const videoSrc = await getValidMultiSources(mSrc);
    if (videoSrc && videoSrc.length) {
      var waData: VideoWAData = {
        chgeSrcEventType: "AnyPage_RaceReplayVideoPlayer",
        country: countryName,
        raceNo: raceNo,
        horse: horse,
      };
      props.handleOpenVideoPlayer(videoSrc, waData);
    } else {
      console.error('videoValidation fail', mSrc, videoSrc);
    }
  } else {
    console.log('[rowData----]', rowData)
    // if (!props?.handleOpenVideoPlayer)
    // {
    //   console.error('handleOpenVideoPlayer func not found')
    //   return;
    // }

    // const videoUrl = generateVideoUrl(rowData?.videoReplayLink);
    // const videoValidation = await validateVideo(videoUrl);
    // if (videoValidation?.hasVideo()) {
    //   var waData: VideoWAData = {
    //     // raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode , raceNo),
    //   };
    //   props.handleOpenVideoPlayer(generateVideoSource(videoUrl.sd, videoUrl.hd), waData);
    // } else {
    //   console.error('videoValidation fail', rowData?.videoReplayLink);
    // }
    // fix SQ0253-1883
    window.open(rowData?.videoReplayLink, '_blank','height=390,width=640');
  }
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: `racing/simulcast_Click_RaceCard_Video-${type== 'LastRace' ? 'LastRace' : 'ExpandHorseRecord'}`,
      buttonName: `racing/simulcast_ClickVideo_Racecard-${type== 'LastRace' ? 'LastRace' : 'ExpandHorseRecord'}`, 
      country: countryName,
      raceNo: raceNo,
      horse: horse,
    });
  };

  const getVideoByDate = (data: any, date: string) => {
    const dateKey = date?.slice(0, 10).replaceAll("-", "");
    return data?.["sim-lr-grouped"]?.[dateKey]?.[lang?.langCode];
  };

  const onBarrierTrialItemClick = async (rowData:any) => {
    const horseName = rowData?.Horse_en || rowData?.horse?.name_en;
    const countryName = myContextState.selectedMeeting?.countryNameEn || '';
    const raceNo = generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo?.valueOf());
    const horse = generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, horseName)
     props?.setvideoTitle(t('barrierTrial'));
     if (!props?.handleOpenVideoPlayer)
    {
      console.error('handleOpenVideoPlayer func not found')
      return;
    }

    const videoUrl = generateVideoUrl(rowData?.barrierTrialLink);
    const videoValidation = await validateVideo(videoUrl);
    if (videoValidation?.hasVideo()) {
      var waData: VideoWAData = {
      };
      props.handleOpenVideoPlayer(generateVideoSource(videoUrl.sd, videoUrl.hd), waData);
    } else {
      console.error('videoValidation fail', rowData?.barrierTrialLink, videoUrl);
    }
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: `racing/simulcast_Click_RaceCard_Video-LastRace`,
      buttonName: `racing/simulcast_ClickVideo_Racecard-BarrierTrial`, 
      country: countryName,
      raceNo: raceNo,
      horse: horse,
    });
  }
  const meetingDate = formattedDate(
    myContextState.selectedMeetingDate,
    "YYYYMMDD"
  );

  const staticHeadCells: any = [
    {
      id: "HorseNo",
      // label: t("race_card_horseNo"),
      label: t("race_card_horseNo_1"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Colour",
      label: t("race_card_colour"),
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Horse",
      label: t("race_card_horse"),
      showSort: false,
      width: "12%",
      minWidth: "12%",
    },
    {
      id: "Weight_lbs",
      label: t("race_card_weight"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Jockey",
      label: t("race_card_jockey"),
      width: "11%",
      minWidth: "11%",
      showSort: true,
    },
     {
      id: "BarrierTrial",
      label: t("barrierTrial"),
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
      showSort: false,
      hiddenCell: !TWO_A_SWITCH
    },
    {
      id: "RaceReplay",
      label: t("raceReplay"),
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
      showSort: false,
      hiddenCell: !OneBSwitch
    },
    {
      id: "Draw",
      label: t("race_card_draw"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Trainer",
      label: t("race_card_trainer"),
      showSort: true,
      width: "11%",
      minWidth: "11%",
    },
    {
      id: "Career",
      label: t("race_card_career"),
      showSort: false,
      width: "8.8%",
      minWidth: "8.8%",
      textAlign: "center",
    },
    {
      id: "Last5Run",
      label: t("race_card_last5run"),
      showSort: false,
      width: "8.8%",
      minWidth: "8.8%",
      textAlign: "center",
    },
    {
      id: "WinRate",
      label: t("race_card_win_rate"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "PlaceRate",
      label: t("race_card_place_rate"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Gear",
      label: t("race_card_gear"),
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "IntRtg",
      label: t("race_card_rtg"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Age",
      label: t("race_card_age"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Sex",
      label: t("race_card_sex"),
      showSort: true,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Sire",
      label: t("race_card_sire"),
      showSort: false,
      width: "10%",
      minWidth: "10%",
    },
    {
      id: "SameDistanceRecord",
      label: "",
      showSort: false,
      width: "8.8%",
      minWidth: "8.8%",
      textAlign: "center",
    },
    {
      id: "SameDistanceWinRate",
      label: "",
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "SameDistancePlaceRate",
      label: "",
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "TurfRecord",
      label: "",
      showSort: false,
      width: "8.8%",
      minWidth: "8.8%",
      textAlign: "center",
    },
    {
      id: "TurfWinRate",
      label: "",
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "TurfPlaceRate",
      label: "",
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Non-TurfRecord",
      label: "",
      showSort: false,
      width: "8.8%",
      minWidth: "8.8%",
      textAlign: "center",
    },
    {
      id: "Non-TurfWinRate",
      label: "",
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Non-TurfPlaceRate",
      label: "",
      showSort: false,
      width: "5%",
      minWidth: "5%",
      textAlign: "center",
    },
    {
      id: "Dam",
      label: "",
      width: "8.8%",
      minWidth: "8.8%",
      showSort: false,
    },
    {
      id: "DamsSire",
      label: "",
      width: "8.8%",
      minWidth: "8.8%",
      showSort: false,
    },
    {
      id: "Owner",
      label: "",
      width: "10%",
      minWidth: "10%",
      showSort: false,
    },
    {
      id: "HorseColour",
      label: "",
      width: "5%",
      minWidth: "5%",
      showSort: false,
      textAlign: "center",
    },
    {
      id: "expandAll",
      label: "Expand All",
      showSort: false,
      textAlign: "center",
      width: "8%",
      minWidth: "8%",
      customStyle: {
        color: "rgba(18, 44, 104, 1)",
        fontWeight: "700",
        cursor: "pointer",
      },
      component: true,
    },
  ];
  const getTempStatsObj = (data: any, type: string, showDash: Boolean) => {
    const tempObjMap: any = {
      ["Dist"]: [
        "SameDistanceRecord",
        "SameDistanceWinRate",
        "SameDistancePlaceRate",
      ],
      ["Turf"]: ["TurfRecord", "TurfWinRate", "TurfPlaceRate"],
      ["NonTurf"]: ["Non-TurfRecord", "Non-TurfWinRate", "Non-TurfPlaceRate"],
    };
    const obj = data?.find((i: any) => i.type === type);
    if (!obj || showDash) {
      const emptyRes = tempObjMap[type].reduce((acc: any, key: any) => {
        acc[key] = "-";
        return acc;
      }, {});
      return emptyRes;
    }

    const totalRun_pre = Number(obj?.totalRun ?? -1);
    if (obj) {
      const calcRes = tempObjMap[type].reduce(
        (acc: any, key: any, index: any) => {
          const firstPlace = Number(obj?.firstPlace ?? 0);
          const secondPlace = Number(obj?.secondPlace ?? 0);
          const thirdPlace = Number(obj?.thirdPlace ?? 0);
          const totalRun = Number(obj?.totalRun ?? 0);
          if (index === 0)
            acc[
              key
            ] = `${totalRun} (${firstPlace}-${secondPlace}-${thirdPlace})`;
          else if (index === 1)
            acc[key] =
              totalRun_pre >= 0
                ? (totalRun > 0
                    ? Number(((firstPlace / totalRun) * 100).toFixed(1))
                    : 0) + "%"
                : "-";
          else if (index === 2)
            acc[key] =
              totalRun_pre >= 0
                ? (totalRun > 0
                    ? Number(
                        (
                          ((firstPlace + secondPlace + thirdPlace) / totalRun) *
                          100
                        ).toFixed(1)
                      )
                    : 0) + "%"
                : "-";
          return acc;
        },
        {}
      );

      return calcRes;
    }
  };
  const getPerformanceStatsData = (
    tableData: any,
    showDash: Boolean = false
  ) => {
    const curperStats = tableData?.performanceStats;
    const TrkObj = getTempStatsObj(curperStats, "Dist", showDash);
    const TurfObj = getTempStatsObj(curperStats, "Turf", showDash);
    const NonTurfObj = getTempStatsObj(curperStats, "NonTurf", showDash);

    return {
      ...TrkObj,
      ...TurfObj,
      ...NonTurfObj,
    };
  };
  const getPossibleColumns = (tableData: any, showDash: Boolean = false) => {
    return {
      Dam: showDash
        ? "-"
        : lang.langType === LANGTYPE_EN
        ? tableData?.damNm?.english ?? "-"
        : tableData?.damNm?.chinese ?? "-",
      DamsSire: showDash
        ? "-"
        : lang.langType === LANGTYPE_EN
        ? tableData?.sireOfDamNm?.english ?? "-"
        : tableData?.sireOfDamNm?.chinese ?? "-",
      Owner: showDash
        ? "-"
        : lang.langType === LANGTYPE_EN
        ? tableData?.ownerNm?.english ?? "-"
        : tableData?.ownerNm?.chinese ?? "-",
      HorseColour: showDash
        ? "-"
        : lang.langType === LANGTYPE_EN
        ? tableData?.colorNm?.english ?? "-"
        : tableData?.colorNm?.chinese ?? "-",
    };
  };
  useEffect(() => {
    if (!selectTabPC) return;

    const curColumnObj = colunmConfigList?.find(
      (i: any) => i.id === selectTabPC
    );

    if (curColumnObj) {
      const lastElement = staticHeadCells.slice(-1)[0];
      const curHeadCell = staticHeadCells
        .filter((i: any) => {
          const target = curColumnObj.columns.find((ii: any) => ii.id === i.id);
          if (!target) return false;
          if (i?.hiddenCell) return false;
          if (target) {
            i.label = target.label;
            return true;
          }
        }).sort(compare("id", curColumnObj?.sortFieldList));

      const curclms = curHeadCell?.map((i: any) => i.id);
      curHeadCell.push(lastElement);
      setcurColumns(curclms);
      setheadCells(curHeadCell);
    }
  }, [colunmConfigList, selectTabPC]);
  useEffect(() => {
    setAllOpen(false);
  }, [raceNo]);
  const getCareer = (stat: any) => {
    let result = "-";
    if (stat) {
      result = `${stat?.numStarts} (${stat?.numFirst}-${stat?.numSecond}-${stat?.numThird})`;
    }
    return result;
  };
  const getMLabel = (labelKey?: string) => {
    return labelKey ? (t(`race_card_${labelKey}_m`, t(`race_card_${labelKey}`, labelKey))) : ''
  }
  useEffect(() => {
    if (props.isMobile) { 
      setRenderData(tableData.map((d: any)=>{
        const totalRun = Number(d?.performanceStats?.filter((x: any) => x.type == "LifeTime")?.[0]?.totalRun ?? -1)
        const isScratched = d.status === runnerStatus.SCRATCHED || d.status === runnerStatus.SCRATCHEDRESERVED;
        const handicapWeight = isScratched ? "-" :  d.handicapWeight;
        const barrierDrawNumber = isScratched ? "-" : d.barrierDrawNumber;
        const jockeyEn = isScratched ? "-" : d?.jockey?.name_en;
        const trainerEn = isScratched ? "-" : d?.trainer?.name_en;
        const last5run = isScratched ? "-" : d?.last6run ? d?.last6run : "-";
        return {
          ...d,
          // override data
          handicapWeight: handicapWeight,
          barrierDrawNumber: barrierDrawNumber,
          jockey: {...d.jockey, name_ch: isScratched ? "-" : d.jockey.name_ch, name_en: jockeyEn},
          trainer: {...d.trainer, name_ch: isScratched ? "-" : d.trainer.name_ch, name_en: trainerEn}, 
          last5run: last5run,
          // for sorting
          HorseNo: d?.horseNo,
          Weight_lbs: defaultValue(handicapWeight, "-"),
          Jockey: jockeyEn,
          Draw: defaultValue(Number(barrierDrawNumber) > 0 ? Number(barrierDrawNumber): "-", "-"),
          Trainer: trainerEn
        }
      }));
      setSortings(mStaticSortings.map((s: any)=>({        
        key: s.id,
        label: getMLabel(s.labelKey),
        type: s.sortType,
      } as Sorting)));
      return;
    }
    if (tableData?.length) {
      const resultArr = props?.tableData?.map((table: any) => {
        const isScratched = [runnerStatus.SCRATCHED, runnerStatus.SCRATCHEDRESERVED].includes(table.status);
        const totalRun = Number(table?.performanceStats?.filter((x: any) => x.type == "LifeTime")?.[0]?.totalRun ?? -1)
        if (isScratched || totalRun < 0) {
          return {
            id: table?.id,
            HorseNo: table.horseNo,
            Colour: table.color,
            Horse:
              lang.langType === LANGTYPE_EN
                ? table?.horse.name_en
                : table?.horse.name_ch,
            Horse_en: table?.horse.name_en,
            Weight_lbs: totalRun < 0 ? Number(table.handicapWeight) : "-",
            Jockey: totalRun < 0 ? table?.jockey.name_en :"-",
            Jockey_ch: totalRun < 0 ? table?.jockey.name_ch : "-",
            Draw: totalRun < 0 ? 
                Number(table.barrierDrawNumber) > 0
                ? Number(table.barrierDrawNumber)
                : "-" 
              : "-",
            Trainer: totalRun < 0 ? table?.trainer.name_en : "-",
            Trainer_ch: totalRun < 0 ? table?.trainer.name_ch : "-",
            Career: "-",
            Last5Run: totalRun < 0 ? "-" : table.last6run ? table.last6run : "-",
            WinRate: "-",
            PlaceRate: "-",
            Gear: totalRun < 0 ? table.gearInfo ? table.gearInfo : "-" : "-",
            IntRtg: totalRun < 0 ? Number(table.currentRating) || "-" : "-",
            Sire: "-",
            Sex: totalRun < 0 ? table?.sexNm?.english : "-",
            Sex_ch: totalRun < 0 ? table?.sexNm?.chinese : "-",
            Age: totalRun < 0 ? Number(table.age) > 0 ? Number(table.age) : "-" : "-",
            ...getPerformanceStatsData(table, true),
            ...getPossibleColumns(table, true),
            status: table.status,
            isScratched: isScratched,
            ...(OneBSwitch && {videoReplayLink: table?.videoReplayLink}),
            ...(TWO_A_SWITCH && {videos: table?.videos, barrierTrialLink: table?.barrierTrialLink,videoLatestLastrun: isScratched ? undefined : table?.videoLatestLastrun })
          };
        } else {
          return {
            id: table?.id,
            HorseNo: Number(table.no),
            Colour: table.color,
            Horse:
              lang.langType === LANGTYPE_EN
                ? table?.horse.name_en
                : table?.horse.name_ch,
            Horse_en: table?.horse.name_en,
            Weight_lbs: Number(table.handicapWeight),
            Jockey:table?.jockey.name_en,
            Jockey_ch:table?.jockey.name_ch,
            Draw:
              Number(table.barrierDrawNumber) > 0
                ? Number(table.barrierDrawNumber)
                : "-",
            Trainer:table?.trainer.name_en,
            Trainer_ch:table?.trainer.name_ch,
            Career: getCareer(table.stat?.[0]),
            Last5Run: table.last6run ? table.last6run : "-",
            WinRate: table.stat
              ? table.stat?.[0]?.numStarts > 0
                ? Number(
                    (
                      (table.stat?.[0]?.numFirst / table.stat?.[0]?.numStarts) *
                      100
                    ).toFixed(1)
                  )
                : 0
              : "-",
            PlaceRate: table.stat
              ? table.stat?.[0]?.numStarts > 0
                ? Number(
                    (
                      ((table.stat?.[0]?.numFirst +
                        table.stat?.[0]?.numSecond +
                        table.stat?.[0]?.numThird) /
                        table.stat?.[0]?.numStarts) *
                      100
                    ).toFixed(1)
                  )
                : 0
              : "-",
            Gear: table.gearInfo ? table.gearInfo : "-",
            IntRtg: Number(table.currentRating) || "-",
            Sire: table.sire ? table.sire : "-",
            Sex: table?.sexNm?.english,
            Sex_ch: table?.sexNm?.chinese,
            Age: Number(table.age),
            ...getPerformanceStatsData(table),
            ...getPossibleColumns(table),
            status: table.status,
            isScratched: isScratched,
            ...(OneBSwitch && {videoReplayLink: table?.videoReplayLink}),
            ...(TWO_A_SWITCH && {videos: table?.videos, barrierTrialLink: table?.barrierTrialLink, videoLatestLastrun: table?.videoLatestLastrun })
          };
        }
      });
      console.log("RaceCardTable", resultArr);

      setRenderData(resultArr);
    }
  }, [props.tableData]);

  const getSortIcon = (id: any) => {
    if (id === orderBy) {
      if (order === "desc") {
        return AsceSort;
      } else {
        return DescSort;
      }
    } else {
      return DefaultSort;
    }
  };
  const handleRequestSort = (property: string, order: Order) => {
    // adobeAnalysis //5. PRJ2555-1434 Sorting preference
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: "racing/simulcast_Click_RaceCard_Sorting",
      sorting: `${property} ${order}`,
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf())
    });
  };
  const createSortHandler = (property: string) => () => {
    if (!hasOrderBy) return;
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    handleRequestSort(property, isAsc ? "desc" : "asc");
  };
  const sortScratchedData = (data:any) => {
    const showAtBottomStatus = ['Scratched', 'ScratchedReserved'];

    data?.sort((a:any, b:any) => {
      if (showAtBottomStatus.includes(a?.status) &&!showAtBottomStatus.includes(b?.status)) {
          return 1; 
      }
      if (!showAtBottomStatus.includes(a?.status) && showAtBottomStatus.includes(b?.status)) {
          return -1; 
      }
      return 0; 
    });
    return data
  }

  const visibleRows = useMemo(() => {
      // sort for escaping scratched runner data, ordering them to the bottom.
      let escapeSrc = !scratchedHorseCells.includes(orderBy);
      const runnerList = escapeSrc ? renderData?.filter((d: any)=> !d.isScratched) : renderData;
      const sortData = _.orderBy(runnerList?.filter((d: any)=> d[orderBy] !== "-"), [orderBy, defaultOrderBy], [order, defaultOrder]);
      let sortEmptyData = _.orderBy(runnerList?.filter((d: any)=> d[orderBy] === "-"), [orderBy, defaultOrderBy], [order, defaultOrder]);
      if (runnerList?.length !== renderData?.length){
        sortEmptyData = sortEmptyData.concat(_.orderBy(renderData?.filter((d: any)=> d.isScratched), [defaultOrderBy], [defaultOrder]));
      }
    return sortData.concat(sortEmptyData);
  }, [order, orderBy]);

  // mobile
  const [selectedTabM, setSelectedTabM] = useState("");

  const renderMobileTable = (table: any, index: any, isReserve?: boolean, isMobile ?: boolean) => {
    const colorPath = getSilkImagePath(
      meetingDate,
      myContextState.selectedMeetingVenueCode,
      myContextState.selectedRaceNo?.toString(),
      table.no
    );
    const totalRun = Number(tableData.find((x:any) => x?.id == table?.id)?.performanceStats?.filter((x: any) => x.type == "LifeTime")?.[0]?.totalRun ?? -1)
    console.log('table.tabType---------', table.tabType, table)
    return (
      <>
        <Div12px />
        <MCardItem key={table?.no}>
          <MCardContent
            id={
              isReserve ? `reserve_table_item_${index}` : `table_item_${index}`
            }
            $top={!myContextState?.upComRaceData?._None ? (isMobile? '132px':'144px') : "0"}
          >
            <MItemStyle isSelect={table.fullFormShow || table.performanceShow}>
              <MItemTitle isSelect={table.fullFormShow || table.performanceShow}>
                <span>{`${table?.no}.${isReserve ? `(${t("race_card_R")}) ` : ""}`}</span>
                <HorseLinkM
                  isSelect={table.fullFormShow || table.performanceShow}
                  target="_blank"
                  href={generateHorseProfileUrl(
                    lang.langCode,
                    myContextState.selectedMeetingDate,
                    myContextState.selectedMeeting?.meetingVenueCode || "",
                    myContextState.selectedRaceNo?.toString(),
                    table?.id,
                    table?.no,
                    "RaceCard"
                  )}
                >
                  {lang.langType === LANGTYPE_EN
                    ? table.horse?.name_en
                    : table.horse?.name_ch}
                </HorseLinkM>
                {table.status === runnerStatus.SCRATCHED ||
                  table.status === runnerStatus.SCRATCHEDRESERVED ? (
                  <ScratchText isMobile>{`(${t("runner_sccratch")})`}</ScratchText>
                ) : null}
              </MItemTitle>
              <MItemTop>
                <MRunnerJTWrapper>
                  <MRunnerJT>
                    <div style={{
                      background: !colorPath ? "" : 'rgb(255, 255, 255)',
                      width: '40px',
                      minWidth: '40px',
                      height: '40px',
                      borderRadius: '20px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      marginLeft: '8px'
                    }}> 
                      <img
                        style={{ maxWidth: "28px", maxHeight: "28px" }}
                        src={generateSilkImagePath(colorPath, lang.langCode)}
                        alt={colorPath}
                        key={colorPath}
                        onError={(e: any) => {
                          e.target.style.display = "none";
                          e.target.parentElement.style.background="none";
                        }}
                      /> 
                    </div>

                    <div style={{ marginLeft: "12px" }}>
                      <div style={{ display: "flex" }}>
                        <MItemName style={{ minWidth: "58px" }} isSelect={table.fullFormShow || table.performanceShow}>{t("race_card_jockey")}</MItemName>
                        <MItemValue isSelect={table.fullFormShow || table.performanceShow}>{lang.langType === LANGTYPE_EN
                            ? table?.jockey.name_en
                            : table?.jockey.name_ch}</MItemValue>
                      </div>
                      <Margintop5 />
                      <div style={{ display: "flex" }}>
                        <MItemName style={{ minWidth: "58px" }} isSelect={table.fullFormShow || table.performanceShow}>{t("race_card_trainer")}</MItemName>
                        <MItemValue isSelect={table.fullFormShow || table.performanceShow}>{lang.langType === LANGTYPE_EN
                            ? table?.trainer.name_en
                            : table?.trainer.name_ch}</MItemValue>
                      </div>
                    </div>  
                  </MRunnerJT>
                  <MRunnerRight>
                    <MItemName isSelect={table.fullFormShow || table.performanceShow}>{t("race_card_draw")}</MItemName>
                    <Margintop5 />
                    <MItemValue isSelect={table.fullFormShow || table.performanceShow}>
                      {table.barrierDrawNumber}
                    </MItemValue>
                  </MRunnerRight>
                </MRunnerJTWrapper>
                {
                    !OneBSwitch ?
                    <MRunnerWLWrapper> 
                    <div>
                      <MItemName isSelect={table.fullFormShow || table.performanceShow}>{t("race_card_WT_lbs")}</MItemName>
                      <MarginLeft12 /> 
                      <MItemValue isSelect={table.fullFormShow || table.performanceShow}>
                        {table.handicapWeight}
                      </MItemValue>
                    </div>
                    <div>
                      <MItemName isSelect={table.fullFormShow || table.performanceShow}>{t("race_card_last5run")}</MItemName>
                      <MarginLeft12 /> 
                      <MItemValue isSelect={table.fullFormShow || table.performanceShow}>
                        {table.last5run}
                      </MItemValue>
                    </div>
                  </MRunnerWLWrapper>
                  : 
                  <MRunnerWLWrapper className="release1b">
                  <div>
                    <MItemName isSelect={table.fullFormShow || table.performanceShow}>{t("race_card_WT_lbs")}</MItemName>
                    <MItemValue isSelect={table.fullFormShow || table.performanceShow}>
                      {table.handicapWeight}
                    </MItemValue>
                  </div>
                  <div>
                    <MItemName isSelect={table.fullFormShow || table.performanceShow}>{t("race_card_last5run")}</MItemName>
                    <MItemValue isSelect={table.fullFormShow || table.performanceShow}>
                      {table.last5run}
                    </MItemValue>
                  </div> 
                  <div>
                    <MItemName isSelect={table.fullFormShow || table.performanceShow}>{t("barrierTrial")}</MItemName>
                    <MItemValue isSelect={table.fullFormShow || table.performanceShow}>
                      {
                        !table?.barrierTrialLink ? "-" :
                        (table.fullFormShow || table.performanceShow) ?
                          <VideoPlayerIcon style={{width:24, height:24}}onClick={() => onBarrierTrialItemClick(table)}/>
                        : 
                          <VideoPlayerIconBlue style={{width:24, height:24}}onClick={() => onBarrierTrialItemClick(table)}/>
                      } 
                    </MItemValue>
                  </div>
                  <div>
                    <MItemName isSelect={table.fullFormShow || table.performanceShow}>{t("raceReplay")}</MItemName>
                    <MItemValue isSelect={table.fullFormShow || table.performanceShow}>
                      {
                        (TWO_A_SWITCH ? !table?.videoLatestLastrun : !table?.videoReplayLink) ? "-" :
                        (table.fullFormShow || table.performanceShow) ?
                          <VideoPlayerIcon style={{width:24, height:24}}onClick={() => onRunReplayItemClick(table, 'LastRace')}/>
                        : 
                          <VideoPlayerIconBlue style={{width:24, height:24}}onClick={() => onRunReplayItemClick(table, 'LastRace')}/>
                      } 
                    </MItemValue>
                  </div>
                  </MRunnerWLWrapper>
                  } 
              </MItemTop>
            </MItemStyle>
            <MItemBottom>
              <LeftBtn
                style={totalRun < 0 ? { width: "100%" } : table.last6run == "" ? { width: "100%" } : { flexBasis: "36%"}}
                onClick={() => handleSelectFullForm(table, index, isReserve)}
                className={
                  table.fullFormShow
                    ? "selected"
                    : ""
                }
              >
                <p>{t("full_form")}</p>
              </LeftBtn>
              {totalRun < 0 ? <></> : table.last6run == "" ? (
                <></>
              ) : (
                <RightBtn
                  onClick={() =>
                    handleSelectPerformance(table, "performance", isReserve)
                  }
                  className={
                    table.performanceShow
                      ? "selected"
                      : ""
                  }
                >
                  <p>{t("performance_by_distance")}</p>
                </RightBtn>
              )}
            </MItemBottom>
          </MCardContent>

          <Collapse in={table.fullFormShow || table.performanceShow}>
            {table.fullFormShow ? (
              <FullFormM
                data={table}
                raceNo={myContextState.selectedRaceNo}
                gearData={props.gearData}
                totalRun={totalRun}
                onRunReplayItemClick={onRunReplayItemClick}
                onBarrierTrialItemClick={onBarrierTrialItemClick}
              />
            ) : null}
            {table.performanceShow ? (
                <RaceCardPerformance
                  type="mobile"
                  variables={{
                    ids: [table?.id],
                    meetingDate: meetingDate,
                    raceNumber: myContextState.selectedRaceNo.toString(),
                  }}
                  horseName={table.horse?.name_en}
                  data={tableData.find((x:any) => x?.id == table?.id)}
                  raceCountry={raceCountry}
                />
              ) : null}
          </Collapse>
        </MCardItem>
      </>
    );
  };  
  const handleSelectPerformance = (
    race: any,
    type: any,
    isReserve?: boolean
  ) => {
    setSelectedTabM(type);
    let newData: any = [];
    if (isReserve) {
      newData = (visibleRows.length ? visibleRows : renderData)?.map((item: any) => {
        if (item.no == race.no) {
          if (type === "fullForm") {
            item.fullFormShow = !item.fullFormShow;
            item.performanceShow = false;
          } else {
            item.performanceShow = !item.performanceShow;
            item.fullFormShow = false;
          }
          item.tabType = type;
        }
        return item;
      });
      setRenderData(newData);
    } else {
      newData = (visibleRows.length ? visibleRows : renderData)?.map((item: any) => {
        if (item.no == race.no) {
          if (type === "fullForm") {
            item.fullFormShow = !item.fullFormShow;
            item.performanceShow = false;
          } else {
            item.performanceShow = !item.performanceShow;
            item.fullFormShow = false;
          }
          item.tabType = type;
        }
        return item;
      });
      setRenderData(newData);
    }
    // adobeAnalysis //8. PRJ2555-1437 Click "Performance by distance" to expand horse details
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: "racing/simulcast_Click_RaceCard-Mobile_DistanceHorseDetails",
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
      horse: generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, race?.horse?.name_en)
    });
  };
  
  const handleSelectFullForm = (
    race: any,
    index?: any,
    isReserve?: boolean
  ) => {
    setSelectedTabM("fullForm");
    let isFullFormShow = true;
    let itemDom: any = null;
    let newData: any = [];
    if (isReserve) {
      itemDom = document.getElementById(`reserve_table_item_${index}`);
      newData = (visibleRows.length ? visibleRows : renderData)?.map((item: any) => {
        if (item.no == race.no) {
          item.fullFormShow = !item.fullFormShow;
          item.performanceShow = false;
          item.tabType = "fullForm";
          isFullFormShow = item.fullFormShow;
        }
        return item;
      });
      setRenderData(newData);
    } else {
      itemDom = document.getElementById(`table_item_${index}`);
      newData = (visibleRows.length ? visibleRows : renderData)?.map((item: any) => {
        if (item.no == race.no) {
          item.fullFormShow = !item.fullFormShow;
          item.performanceShow = false;
          item.tabType = "fullForm";
          isFullFormShow = item.fullFormShow;
        }
        return item;
      });
      setRenderData(newData);
    }
    if (!isFullFormShow && Number(itemDom?.getBoundingClientRect().top) <= 0) {
      setTimeout(() => {
        itemDom?.scrollIntoView();
      }, 1);
    }

    // adobeAnalysis //7. PRJ2555-1436 Click "FullForm" to expand horse details
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: "racing/simulcast_Click_RaceCard-Mobile_FullFormHorseDetails",
      raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
      horse: generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, race?.horse?.name_en)
    });
  };
  const handleChangeSortingMobile = (sorting: Sorting, order: Order) => {    
    setOrder(order);
    setOrderBy(sorting.key);
    handleRequestSort(sorting.key, order);
  }

  // expose this function to father layer
  React.useImperativeHandle(ref, () => ({
    resetDefaultSort : () => {
      setOrder("asc")
      setOrderBy("HorseNo")
      handleRequestSort("HorseNo", "asc")
    }
  }));

  const setRaceCardDetailAllOpen = () => {
    const data = (visibleRows.length ? visibleRows : renderData);
    data.forEach((x: any) => {
      x.isOpen = !allOpen
    });
    setAllOpen(!allOpen);
     
    if(!allOpen)
    {
      // adobeAnalysis //6
      adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
        pageId: "racing/simulcast",
        eventId: "racing/simulcast_Click_RaceCard-Desktop_ExpandHorseDetails",
        raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        horse: generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, "All")
      });
    } 
  }

  const handleOpen =(id: string, isOpen?: boolean)=>{ 
    const data = (visibleRows.length ? visibleRows : renderData)
    const s = data?.filter((x: any) => x.id != id && x.isOpen == true)?.length
    setAllOpen((s == data?.length - 1) && isOpen  ? true : false);
  }

  // handle sticky scrollable thead
  const stickyTblRef = useRef<HTMLDivElement | null>(null);
  const tblRef = useRef<HTMLDivElement | null>(null);
  const syncScroll = (e: any, targetEle: HTMLElement | null) => {
    const scroll = e.target.scrollLeft ?? 0;
    // console.log('syncScroll', scroll);
    targetEle?.scrollTo({left: scroll});
  }

  // overlap 2 table
  const overlapTbl = (sourceTbl: HTMLElement | null, targetTbl: HTMLElement | null) => {
    if (!sourceTbl?.offsetHeight) return;
    console.log('overlapTbl execute', sourceTbl?.offsetHeight);
    const sourceHeight = `-${sourceTbl?.offsetHeight}px`
    if(targetTbl && targetTbl.style.marginTop !== sourceHeight){
      targetTbl.style.marginTop = sourceHeight;
    }
  }

  // handle table width change
  const syncHeaderWidth = (ele: HTMLElement | null) => {
    if (!ele || !stickyTblRef.current) return;
    const count = ele.getAttribute('data-index');
    const stickyHeaderCol: HTMLElement | null = stickyTblRef.current.querySelector(`th[data-index="${count}"]`);
    if (stickyHeaderCol && stickyHeaderCol.offsetWidth !== ele.offsetWidth) {
      console.log('resizeObserver - syncHeaderWidth execute', count, ele.offsetWidth);
      stickyHeaderCol.style.minWidth = `${ele.offsetWidth}px`;
      stickyHeaderCol.style.maxWidth = `${ele.offsetWidth}px`;
    }
  }

  // setup observer
  const thResizeObserver = new ResizeObserver((entries) => {
    requestAnimationFrame(() => {
      for (let entry of entries) {
        syncHeaderWidth(entry.target as HTMLElement);
      }
    });
  });

  const theadResizeObserver = new ResizeObserver((entries) => {
    requestAnimationFrame(() => {
      if (!isSticky) return;
      overlapTbl(entries?.[0]?.target as HTMLElement, tblRef.current);
    });
  });

  useEffect(()=>{
    if (tblRef.current && stickyTblRef.current) {
      const tblWrapper = tblRef.current;
      const tblHeader: HTMLElement | null = tblWrapper.querySelector('thead');
      const headers: NodeListOf<HTMLTableCellElement> = tblWrapper.querySelectorAll('thead th');
          
      // add observer to header
      if (tblHeader) {
        theadResizeObserver.observe(tblHeader);
        console.log('theadResizeObserver - connected');
        return () => {
          theadResizeObserver.disconnect();
          console.log('theadResizeObserver - disconnected');
        }
      }
    }
  }, [stickyTblRef, tblRef]);

  useEffect(()=>{
    if (tblRef.current) {
      const tblWrapper = tblRef.current;
      const headers: NodeListOf<HTMLTableCellElement> = tblWrapper.querySelectorAll('thead th');

      if (headers.length && tblRef.current && stickyTblRef.current) {
        // add observer to header
        headers.forEach((headerCol) => {
          // syncWidth(tblHeader);
          thResizeObserver.observe(headerCol);
        })
        console.log('thResizeObserver - header - connected', headers.length);
        return () => {
          thResizeObserver.disconnect();
          console.log('thResizeObserver - header - disconnected');
        }
      }
    }
  }, [tblRef.current?.querySelectorAll('th')]);

  return !props.isMobile ? (
    <div style={{position: "relative"}} data-sticky-thead={isSticky}>
      { isSticky && 
      <MyTableContainer id="race_card_table_sticky_wrapper" onScroll={(e:any) => syncScroll(e, tblRef?.current)}
        ref={stickyTblRef}
        sx={{
          position: 'sticky',
          top: !myContextState?.upComRaceData?._None? (props.isMobile? '132px':'144px'):'0px',
          zIndex: 11,
          borderRadius: '0 0 0 0 !important',
          // hide scrollbar
          '& ::-webkit-scrollbar': {
            display: 'none', /* for Chrome, Safari and Opera */
          },
          '-ms-overflow-style': 'none',  /* IE and Edge */
          scrollbarWidth: 'none',  /* Firefox */
        }}
        >
        <Table
          id="race_card_table_sticky"
          sx={{minWidth: 750}}
          aria-labelledby="tableTitle"
        >
          <TableHead id="race_card_table_head">
            <TableRow>
              {headCells.map((headCell: any, idx: number) =>
                headCell.showSort ? (
                  <CustomTableCell
                    data-index={idx}
                    key={headCell.id}
                    align="left"
                    padding={"none"}
                    style={{
                      ...headCell.customStyle,
                      width: headCell.width,
                      minWidth: headCell.minWidth && `${headCell.minWidth}px`,
                      textAlign: headCell.textAlign ?? "left",
                    }}
                  >
                    <CustomSortLabel
                      active={
                        headCell.showSort && hasOrderBy
                          ? orderBy === headCell.id
                          : false
                      }
                      isReserve={isReserve}
                      onClick={createSortHandler(headCell.id)}
                      IconComponent={hasOrderBy && getSortIcon(headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                    </CustomSortLabel>
                  </CustomTableCell>
                ) : (
                  <CustomTableCell
                    data-index={idx}
                    key={headCell.id}
                    style={{
                      ...headCell.customStyle,
                      width: headCell.width,
                      minWidth: headCell.minWidth && `${headCell.minWidth}px`,
                      textAlign: headCell.textAlign ?? "left",
                    }}
                  >
                    {headCell.component ? (
                      <div
                        onClick={() => setRaceCardDetailAllOpen()}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          lineHeight: "18px",
                        }}
                      >
                        {allOpen ? t("collapse_all") : t("expand_all_racecard")}
                        <LabelCpImg
                          open={allOpen}
                          style={{ marginLeft: "4.9px" }}
                          src={`${myContextState.assetPrefix}/race_card_expand.svg`}
                        />
                      </div>
                    ) : (
                      headCell.label
                    )}
                  </CustomTableCell>
                )
              )}
            </TableRow>
          </TableHead>
        </Table>
      </MyTableContainer>
      }
      <MyTableContainer id="race_card_table_wrapper" onScroll={(e:any) => isSticky && syncScroll(e, stickyTblRef?.current)}
        ref={tblRef}
        sx={{...(isSticky && {marginTop: '-44px'})}}>
        <Table
          id="race_card_table"
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
        >
          <TableHead
            id="race_card_table_head"
            style={{
              position: "sticky",
              top: "0",
              zIndex: "1",
              ...(isSticky && {visibility: 'hidden'}),
            }}
          >
            <TableRow>
              {headCells.map((headCell: any, idx:number) =>
                headCell.showSort ? (
                  <CustomTableCell
                    data-index={idx}
                    key={headCell.id}
                    align="left"
                    padding={"none"}
                    style={{
                      ...headCell.customStyle,
                      width: headCell.width,
                      minWidth: headCell.minWidth && `${headCell.minWidth}px`,
                      textAlign: headCell.textAlign ?? "left",
                    }}
                  >
                    <CustomSortLabel
                      active={
                        headCell.showSort && hasOrderBy
                          ? orderBy === headCell.id
                          : false
                      }
                      isReserve={isReserve}
                      onClick={createSortHandler(headCell.id)}
                      IconComponent={hasOrderBy && getSortIcon(headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc"
                            ? "sorted descending"
                            : "sorted ascending"}
                        </Box>
                      ) : null}
                    </CustomSortLabel>
                  </CustomTableCell>
                ) : (
                  <CustomTableCell
                    data-index={idx}
                    key={headCell.id}
                    style={{
                      ...headCell.customStyle,
                      width: headCell.width,
                      minWidth: headCell.minWidth && `${headCell.minWidth}px`,
                      textAlign: headCell.textAlign ?? "left",
                    }}
                  >
                    {headCell.component ? (
                      <div
                        onClick={() => setRaceCardDetailAllOpen()}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          lineHeight: "18px",
                        }}
                      >
                        {allOpen ? t("collapse_all") : t("expand_all_racecard")}
                        <LabelCpImg
                          open={allOpen}
                          style={{ marginLeft: "4.9px" }}
                          src={`${myContextState.assetPrefix}/race_card_expand.svg`}
                        />
                      </div>
                    ) : (
                      headCell.label
                    )}
                  </CustomTableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody id="race_card_table_body">
            {(visibleRows.length ? visibleRows : renderData).map((row: any, idxKey:any) => {
              const showLastrunReplay = TWO_A_SWITCH ? row?.videoLatestLastrun : row?.videoReplayLink;
              return (
              <CollapsibleTable
                allOpen={allOpen}
                key={row.id}
                row={row}
                gearData={props.gearData}
                raceNo={raceNo}
                propDetail={propDetail}
                propDynamicColumn={propDynamicColumn}
                curColumns={curColumns}
                tableData={tableData}
                isReserve={isReserve}
                raceCountry={raceCountry}
                handleOpen={(id: string, isOpen?: boolean) => handleOpen(id, isOpen)}
                onRunReplayItemClick={onRunReplayItemClick}
                onBarrierTrialItemClick={onBarrierTrialItemClick}
                idxKey={idxKey}
                showLastrunReplay={showLastrunReplay}
              />
            )})}
          </TableBody>
        </Table>
      </MyTableContainer>
    </div>
  ) : (
    <MCardListWrapper>
      {
        !props.isReserve ? (        
          <MCardListHeader ref={BtnGrpRef}>
            <span>{t("race_card")}</span>
            <PopUpSorter
              anchorEl={BtnGrpRef}
              sortings={sortings}
              selectedOrder={order}
              selectedOrderBy={orderBy}
              handleChangeSorting={handleChangeSortingMobile}/>
          </MCardListHeader>
        ) : (
          <MReserveText id="race_card_reserve_title_m">
            {t("race_card_reserve")}
          </MReserveText>
        )
      }
      {(visibleRows.length ? visibleRows : renderData)?.map((table: any, index: any) =>
        renderMobileTable(table, index, props.isReserve, props.isMobile)
      )}
    </MCardListWrapper>
  );
});

EnhancedTable.displayName = 'EnhancedTable'; // fix jenkins build

export default EnhancedTable;

const CollapsibleTable = (props: any) => {
  const { row, raceNo, propDynamicColumn, propDetail, curColumns, allOpen, tableData, isReserve, raceCountry, showLastrunReplay } = props;
  const [open, setOpen] = useState(false);
  const { state: lang } = useLanguage();
  const { t } = lang;
  const { state: myContextState } = useMyContext();

  const meetingDate = formattedDate(
    myContextState.selectedMeetingDate,
    "YYYYMMDD"
  );
  const colorPath = getSilkImagePath(
    meetingDate,
    myContextState.selectedMeetingVenueCode,
    raceNo,
    row.HorseNo
  );

  const totalRun = Number(tableData?.find((x:any) => x?.id == row?.id)?.performanceStats?.filter((x: any) => x.type == "LifeTime")?.[0]?.totalRun ?? -1)
  useEffect(() => { 
    setOpen(row.isOpen); 
    // if(allOpen)
    // {
    //   // adobeAnalysis //6
    //   adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
    //     pageId: "racing/simulcast",
    //     eventId: "racing/simulcast_Click_RaceCard-Desktop_ExpandHorseDetails",
    //     raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
    //     horse: generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, "All")
    //   });
    // } 
  }, [allOpen]);

  const horseLink = generateHorseProfileUrl(
    lang.langCode,
    myContextState.selectedMeetingDate,
    myContextState.selectedMeetingVenueCode,
    raceNo?.toString(),
    row.id,
    row.HorseNo,
    "RaceCard"
  );

  const [showGearLegend, setShowGearLegend] = useState(false);
  const handleClickGear = (e: any) => {
    setShowGearLegend(true);
    setTimeout(() => {
      const gearElementsB = e.target?.getElementsByTagName("div")[0];
      if (gearElementsB) {
        gearElementsB.style.display = "block";
        gearElementsB.style.top = `${
          e.target.offsetTop - gearElementsB.offsetHeight
        }px`;
        gearElementsB.style.left = `${
          e.target.getBoundingClientRect().x - (600 - e.target.offsetWidth)
        }px`;
      }
    }, 300);
  };
  const handleLeaveGear = () => {
    setShowGearLegend(false);
  };

  const renderConfigColumsTableCell = (id: string, isOpen: any) => {
    //6. PRJ2555-1435 Click to expand horse detail
    // adobeData_clickToExpandBtns();
    switch (id) {
      case "HorseNo":
        return (
          <CustomTableCell isOpen={isOpen} isHorseNo align="center">
            {`${row.HorseNo}${isReserve ? `(${t("race_card_R")})` : ''}`}
          </CustomTableCell>
        );
      case "Colour":
        return (
          <CustomTableCell align="center">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {row.Colour === "-" ? (
              ""
            ) : (
              <ColorWrapper>
                <img
                  id={`race_card_colour_${row.HorseNo}`}
                  style={{ maxWidth: "28px", maxHeight: "28px" }}
                  src={generateSilkImagePath(colorPath, lang.langCode)}
                  alt={colorPath}
                  key={colorPath}
                  onError={(e: any) => { 
                    e.target.style.display = "none";
                    e.target.parentElement.style.background="none";
                  }}
                />
              </ColorWrapper>
            )}
            </div>
          </CustomTableCell>
        );
      case "Horse":
        return (
          <CustomTableCell
            customStyle={{
              color: "rgba(18, 44, 104, 1)",
              lineHeight: '20px',
              paddingTop: '14px',
              paddingBottom: '13px',
            }}
            isHorse
            isOpen={isOpen}
            align="left"
          >
            <HorseLink isOpen={isOpen} target="_blank" href={horseLink}>
              {row.Horse}
            </HorseLink>
            {row.status === runnerStatus.SCRATCHED ||
            row.status === runnerStatus.SCRATCHEDRESERVED ? (
              <ScratchText>{`(${t("runner_sccratch")})`}</ScratchText>
            ) : null}
          </CustomTableCell>
        );
      case "Weight_lbs":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.Weight_lbs}
          </CustomTableCell>
        );
      case "BarrierTrial":
        return (
          <CustomTableCell isOpen={isOpen} align="center" >
            {row?.barrierTrialLink? (row.isOpen ? 
            <VideoPlayerIcon style={{cursor: "pointer", width:24, height:24}} 
            onClick={() => props?.onBarrierTrialItemClick(row)}/> :
            <VideoPlayerIconBlue style={{cursor: "pointer", width:24, height:24}} 
            onClick={() => props?.onBarrierTrialItemClick(row)}/>) : "-"}
          </CustomTableCell>
        );
        
      case "RaceReplay":
        return (
          <CustomTableCell isOpen={isOpen} align="center" >
            { showLastrunReplay ? (row.isOpen ? 
            <VideoPlayerIcon style={{cursor: "pointer", width:24, height:24}} 
            onClick={() => props?.onRunReplayItemClick(row, 'LastRace')}/> :
            <VideoPlayerIconBlue style={{cursor: "pointer", width:24, height:24}} 
            onClick={() => props?.onRunReplayItemClick(row, 'LastRace')}/>) : "-"}
          </CustomTableCell>
        );
      case "Jockey":
        return (
          <CustomTableCell isOpen={isOpen} align="left">
            { lang.langType === LANGTYPE_EN ? row.Jockey : row.Jockey_ch}
          </CustomTableCell>
        );
      case "Draw":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.Draw}
          </CustomTableCell>
        );
      case "Trainer":
        return (
          <CustomTableCell isOpen={isOpen} align="left">
            {lang.langType === LANGTYPE_EN ? row.Trainer : row.Trainer_ch}
          </CustomTableCell>
        );
      case "Career":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.Career}
          </CustomTableCell>
        );
      case "Last5Run":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.status === runnerStatus.SCRATCHED ||
            row.status === runnerStatus.SCRATCHEDRESERVED
              ? "-"
              : row.Last5Run}
          </CustomTableCell>
        );
      case "WinRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.WinRate !== "-" ? `${row.WinRate}%` : "-"}
          </CustomTableCell>
        );
      case "PlaceRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.PlaceRate !== "-" ? `${row.PlaceRate}%` : "-"}
          </CustomTableCell>
        );
      case "Gear":
        return (
          <CustomTableCell
            isOpen={isOpen}
            align="center"
            sx={{ cursor: "pointer", color: "#122c68" }}
            onClick={(e: any) => handleClickGear(e)}
            onMouseLeave={handleLeaveGear}
          >
            {row.Gear}
            {showGearLegend &&
              row.Gear != "-" &&
              props?.gearData?.length > 0 && (
                <GearInfo gear={row.Gear} gearData={props.gearData}></GearInfo>
              )}
          </CustomTableCell>
        );
      case "IntRtg":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.IntRtg}
          </CustomTableCell>
        );
      case "Age":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row.Age}
          </CustomTableCell>
        );
      case "Sex":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {lang.langType === LANGTYPE_EN ? row.Sex : row.Sex_ch}
          </CustomTableCell>
        );
      case "Sire":
        return (
          <CustomTableCell isOpen={isOpen} align="left">
            {row.Sire}
          </CustomTableCell>
        );
      case "SameDistanceRecord":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["SameDistanceRecord"]}
          </CustomTableCell>
        );
      case "SameDistanceWinRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["SameDistanceWinRate"]}
          </CustomTableCell>
        );
      case "SameDistancePlaceRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["SameDistancePlaceRate"]}
          </CustomTableCell>
        );
      case "TurfRecord":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["TurfRecord"]}
          </CustomTableCell>
        );
      case "TurfWinRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["TurfWinRate"]}
          </CustomTableCell>
        );
      case "TurfPlaceRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["TurfPlaceRate"]}
          </CustomTableCell>
        );
      case "Non-TurfRecord":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["Non-TurfRecord"]}
          </CustomTableCell>
        );
      case "Non-TurfWinRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["Non-TurfWinRate"]}
          </CustomTableCell>
        );
      case "Non-TurfPlaceRate":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["Non-TurfPlaceRate"]}
          </CustomTableCell>
        );
      case "Dam":
        return (
          <CustomTableCell isOpen={isOpen} align="left">
            {row?.["Dam"]}
          </CustomTableCell>
        );
      case "DamsSire":
        return (
          <CustomTableCell isOpen={isOpen} align="left">
            {row?.["DamsSire"]}
          </CustomTableCell>
        );
      case "Owner":
        return (
          <CustomTableCell isOpen={isOpen} align="left">
            {row?.["Owner"]}
          </CustomTableCell>
        );
      case "HorseColour":
        return (
          <CustomTableCell isOpen={isOpen} align="center">
            {row?.["HorseColour"]}
          </CustomTableCell>
        );
      default:
        return null;
    }
  };

  const renderConfigColumsTableCellScratched = (id: string, isOpen: any) => {
    const otherNum = curColumns.length - 3; 
    switch (id) {
      case "HorseNo":
        return (
          <CustomTableCell isOpen={isOpen} isHorseNo align="center">
            {`${row.HorseNo}${isReserve ? `(${t("race_card_R")})` : ''}`}
          </CustomTableCell>
        );
      case "Colour":
        return (
          <CustomTableCell align="center">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {row.Colour === "-" ? (
              ""
            ) : (
              <ColorWrapper>
                <img
                  id={`race_card_colour_${row.HorseNo}`}
                  style={{ maxWidth: "28px", maxHeight: "28px" }}
                  src={generateSilkImagePath(colorPath, lang.langCode)}
                  alt={colorPath}
                  key={colorPath}
                  onError={(e: any) => { 
                    e.target.style.display = "none";
                    e.target.parentElement.style.background="none";
                  }}
                />
              </ColorWrapper>
            )}
            </div>
          </CustomTableCell>
        );
      case "Horse":
        return (
          <CustomTableCell
            customStyle={{
              color: "rgba(18, 44, 104, 1)",
              lineHeight: '20px',
              paddingTop: '14px',
              paddingBottom: '13px',
            }}
            isHorse
            isOpen={isOpen}
            align="left"
          >
            <HorseLink isOpen={isOpen} target="_blank" href={horseLink}>
              {row.Horse}
            </HorseLink> 
          </CustomTableCell>
        );
        case "Other":
          return (
            <CustomTableCell isOpen={isOpen} colSpan={otherNum} align="center">
              ({t('result_scr')})
            </CustomTableCell>
          );
      default:
        return null;
  }
};

  const setRaceCardDetailOpen = () => {
    props?.handleOpen(row.id, !open);
    setOpen(!open); 
    row.isOpen = !open
    if(!open)
    { 
      // adobeAnalysis //6
      adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
        pageId: "racing/simulcast",
        eventId: "racing/simulcast_Click_RaceCard-Desktop_ExpandHorseDetails",
        raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        horse: generateAdobeDataHorseName(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, row.Horse_en)
      });
    }
  }
  return (
    <>
      <StyledTableRow isOpen={row.isOpen}>
        {row.status === runnerStatus.SCRATCHED ||
          row.status === runnerStatus.SCRATCHEDRESERVED ? 
          scratchedHorseCells?.map((i: string) => renderConfigColumsTableCellScratched(i, row.isOpen)) :
          curColumns?.map((i: string) => renderConfigColumsTableCell(i, row.isOpen)) }
      {/* {curColumns?.map((i: string) => renderConfigColumsTableCell(i, open))} */}
        <CustomTableCell
          onClick={() => setRaceCardDetailOpen()}
          customStyle={{ cursor: "pointer" }}
          align="center"
        >
          <CpImg open={row.isOpen} src={`${myContextState.assetPrefix}/race_card_expand_black.svg`} />
        </CustomTableCell>
      </StyledTableRow>
      <TableRow>
        <CustomTableCell
          customStyle={{ padding: 0, height: "auto !important" }}
          colSpan={18}
        >
          <Collapse
            sx={{
              background: "#C1CBE1",
            }}
            in={row.isOpen}
            timeout="auto"
            unmountOnExit
          >
            {
            totalRun >= 0 ?
            propDetail?.filter((item: any) => item.id?.includes(row.id))?.[0]?.horseFormRecord?.length > 0 ? (
              <div style={{ padding: "12px 12px 56px" }}>
              {" "}
              <RaceCardPerformance
                type="pc"
                variables={{
                  ids: [row?.id],
                  meetingDate: meetingDate,
                  raceNumber: myContextState.selectedRaceNo.toString(),
                }}
                horseName={row.Horse_en}
                data={tableData.find((x:any) => x?.id == row?.id)}
                raceCountry={raceCountry}
              />
              <DetailTable
                horseId={row.id}
                dynamicColumn={propDynamicColumn}
                data={propDetail}
                raceNo={raceNo}
                gearData={props.gearData}
                type="raceCard"
                rowData={row}
                onRunReplayItemClick={props.onRunReplayItemClick}
                onBarrierTrialItemClick={props.onBarrierTrialItemClick}
              />
            </div>
            ) : (
              <WrapperUnraced>
                <DivUnraced>{t("unraced")}</DivUnraced>
              </WrapperUnraced> 
            ) : (
              <WrapperUnraced>
                <DivUnraced>{t("unavailable")}</DivUnraced>
              </WrapperUnraced> 
            )
          }
          </Collapse>
        </CustomTableCell>
      </TableRow>
    </>
  );
};